import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Empty, List, Skeleton, Space, Tag } from "antd";
import { PlusOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { formatDay, formatEuro } from "../workReports/format";
import { listCases } from "./api";
import { STATUS_COLORS, statusLabels } from "./labels";
import "./funding.css";

/** The Fördermittel cases of one project, for the project page's tab. */
const FundingPanel = ({ project, client }) => {
  const { t, i18n } = useTranslation("dashboard");
  const history = useHistory();
  const [data, setData] = useState(null);
  const [denied, setDenied] = useState(false);
  const labels = statusLabels(t);

  useEffect(() => {
    let cancelled = false;
    listCases({ project })
      .then(res => !cancelled && setData(res.data.data))
      .catch(error => {
        if (cancelled) return;
        if (error?.response?.status === 403) setDenied(true);
        else generalErrorAlert(error);
      });
    return () => {
      cancelled = true;
    };
  }, [project]);

  if (denied) return null;
  if (!data) return <Skeleton active paragraph={{ rows: 3 }} />;

  const query = new URLSearchParams({
    new: "1",
    project,
    ...(client ? { client } : {})
  }).toString();
  return (
    <div className="funding-page fu-panel">
      <Space wrap className="mb-3">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push(`/user/funding?${query}`)}
        >
          {t("New funding case")}
        </Button>
      </Space>
      {data.length ? (
        <List
          bordered
          dataSource={data}
          renderItem={item => (
            <List.Item
              className="fu-panel-item"
              onClick={() => history.push(`/user/funding/${item._id}`)}
              extra={<RightOutlined />}
            >
              <List.Item.Meta
                title={
                  <Space wrap>
                    <span>{item.number}</span>
                    <Tag color={STATUS_COLORS[item.status]}>{labels[item.status]}</Tag>
                    {item.errorCount > 0 && (
                      <Tag color="error">{t("{{n}} problems", { n: item.errorCount })}</Tag>
                    )}
                  </Space>
                }
                description={
                  <Space wrap size={4}>
                    <span>{item.programName}</span>
                    <span>
                      · {t("Estimate")}: {formatEuro(item.estimate?.subsidyCents, i18n.language)}
                    </span>
                    {item.nextDeadline && (
                      <span>
                        · {t("Next deadline")}: {formatDay(item.nextDeadline)}
                      </span>
                    )}
                  </Space>
                }
              />
            </List.Item>
          )}
        />
      ) : (
        <Empty description={t("No funding cases for this project yet.")} />
      )}
    </div>
  );
};

export default FundingPanel;
